import jQuery from "jquery";
import { bindAddToCBButtons } from "../collections/builder/add_search_result_button";

const SearchResultCards = {
  allowToBeAddedToCollections() {
    if (!window.builderContext) return;
    // "+" should always be visible
    bindAddToCBButtons();
    if (jQuery("#new-builder:visible").length) {
      this.bindDragAndDrop();
    }
  },

  bindDragAndDrop() {
    const dragStartEvent = new Event("custom-dragstart");
    const dragEndEvent = new Event("dragend");
    jQuery(".search-result-item:not(.membership-locked)").draggable({
      revert: "invalid",
      containment: ".search-results-container",
      scroll: false,
      zIndex: 9999,
      cursorAt: {
        left: 25,
        top: 30,
      },
      cursor: "pointer",
      helper() {
        const data = jQuery(this).data();
        const classType = data.type;
        const icon = jQuery(this).find(".panel-resource").clone();
        const { id, itemType, isRequireTeacherAcknowledgment } = data;
        icon.find(".sample-text, .collection-count").remove();
        return jQuery(
          `<div style='width:150px; height:auto; pointer-events:none'
            data-id='${id}'
            data-class-type='${classType}'
            data-collection-item-type='${itemType}'
            data-is-require-teacher-acknowledgment='${isRequireTeacherAcknowledgment}'>
            ${jQuery("<div>").append(icon.clone()).html()}
          </div>`
        );
      },
      start() {
        document.dispatchEvent(dragStartEvent);
        jQuery(this).css({ opacity: 0.5, "pointer-events": "none" });
      },
      stop() {
        document.dispatchEvent(dragEndEvent);
        jQuery(this).css({ opacity: 1, "pointer-events": "all" });
      },
    });
    return true;
  },
};

export default SearchResultCards;
